







import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';

const TOUCH_EVENTS = ['touchstart', 'touchmove', 'touchend'];

/**
 * 弹跳类型
 */
export enum BounceType {
  /** 顶部支持弹跳 */
  Up = 'up',
  /** 底部支持弹跳 */
  Down = 'down',
}

@Component
export default class BounceContainer extends Vue {
  @Ref('container') container!: HTMLDivElement;
  @Ref('subContainer') subContainer!: HTMLDivElement;
  /**
   * 弹跳类型,默认底部弹跳
   */
  @Prop({ default: BounceType.Down }) public type!: BounceType;

  /**
   * 是否启用弹跳效果，默认不启用
   */
  @Prop({ default: false }) public enable!: boolean;

  startY = 0;
  distanse = 100;

  @Watch('enable')
  onEnableStateChanged() {
    if (this.enable) {
      this.bindTouchEvents();
    } else {
      this.unbindTouchEvents();
    }
  }

  /**
   * 检查弹跳类型和手势滑动是否匹配
   */
  checkType(distance: number) {
    if (distance === 0) {
      return false;
    }
    // 顶部弹跳，需要向下滑动一定距离
    if (this.type === BounceType.Up && distance < 0) {
      return false;
    }
    // 底部弹跳，需要向上滑动一定距离
    if (this.type === BounceType.Down && distance > 0) {
      return false;
    }
    // 底部弹跳时，需要确保容器底部可见，同理顶部弹跳时也要确保位置先在顶部
    if (!this.checkVisible()) {
      return;
    }
    // 需要滑动一定距离才认为是用户主动操作
    if (Math.abs(distance) < this.distanse) {
      return false;
    }
    return true;
  }

  /**
   * 检查弹跳容器是否在可滑动位置
   */
  checkVisible() {
    const { top, bottom } = this.subContainer.getBoundingClientRect();
    const height = window.innerHeight || document.documentElement.clientHeight;
    // 顶部弹跳需要确保页面滑动到顶部
    if (this.type === BounceType.Up &&  top < 0) {
      return false;
    }
    // 底部弹跳需要确保页面拉到底部
    if (this.type === BounceType.Down && bottom > height) {
      return false;
    }
    return true;
  }

  /**
   * 处理滑动事件
   */
  handleTouch(evt: Event) {
    const e = evt as TouchEvent;
    let y = 0;
    if (!this.enable) {
      return;
    }
    switch (e.type) {
      case 'touchstart':
        this.startY = e.changedTouches[0].clientY;
        break;
      case 'touchmove':
        y = Math.min(e.changedTouches[0].clientY - this.startY, this.distanse);
        Object.assign(this.subContainer.style, { transition: 'none', transform: `translateY(${0.3 * y}px)` });
        break;
      case 'touchend':
        y = e.changedTouches[0].clientY - this.startY;
        // 回弹
        Object.assign(this.subContainer.style, { transition: 'transform .5s', transform: 'translateY(0px)' });
        if (!this.checkType(y)) {
          break;
        }
        // 计算弹跳方向
        setTimeout(() => {
          this.subContainer.style.transform = 'none';
          this.$emit('scrollEnd', y > 0 ? BounceType.Up : BounceType.Down);
        }, 600);
        break;
    }
  }
  /**
   * 绑定触摸事件
   */
  bindTouchEvents() {
    TOUCH_EVENTS.forEach((key) => {
      this.container.addEventListener(key, this.handleTouch);
    });
  }

  /**
   * 解绑触摸事件
   */
  unbindTouchEvents() {
    TOUCH_EVENTS.forEach((key) => {
      this.container.removeEventListener(key, this.handleTouch);
    });
  }

  mounted() {
    if (this.enable) {
      this.bindTouchEvents();
    }
  }

  destroyed() {
    this.unbindTouchEvents();
  }
}
